import React from 'react';

import StatItem from './StatItem';
import { FaPaperPlane, FaPencilAlt, FaSurprise } from 'react-icons/fa';
import Wrapper from '../assets/wrappers/StatsContainer';
import { useSelector } from 'react-redux';

const StatsContainer = () => {
  const { stats } = useSelector((store) => store.user);
  const defaultStats = [
    {
      title: 'working draft',
      count: stats.text || 0,
      icon: <FaPencilAlt />,
      color: '#e9b949',
      bcg: '#fcefc7',
    },
    {
      title: 'NFT minted',
      count: stats.nft || 0,
      icon: <FaPaperPlane />,
      color: '#647acb',
      bcg: '#e0e8f9',
    },
    {
      title: 'Mint failure',
      count: stats.failed || 0,
      icon: <FaSurprise />,
      color: '#d66a6a',
      bcg: '#ffeeee',
    },
  ];

  return (
    <Wrapper>
      {defaultStats.map((item, index) => {
        return <StatItem key={index} {...item} />;
      })}
    </Wrapper>
  );
};

export default StatsContainer;
